// Generated by Ktorfit
@file:Suppress("warnings")

package org.mifos.mobile.core.network.services

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import de.jensklingenberg.ktorfit.annotationsAttributeKey
import de.jensklingenberg.ktorfit.converter.TypeData
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.parameter
import io.ktor.client.request.setBody
import io.ktor.client.statement.HttpResponse
import io.ktor.http.HttpMethod
import io.ktor.http.URLBuilder
import io.ktor.http.decodeURLQueryComponent
import io.ktor.http.encodeURLPath
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.Long
import kotlin.OptIn
import kotlin.Suppress
import kotlin.collections.List
import kotlinx.coroutines.flow.Flow
import org.mifos.mobile.core.model.entity.beneficiary.Beneficiary
import org.mifos.mobile.core.model.entity.beneficiary.BeneficiaryPayload
import org.mifos.mobile.core.model.entity.beneficiary.BeneficiaryUpdatePayload
import org.mifos.mobile.core.model.entity.templates.beneficiary.BeneficiaryTemplate

@OptIn(InternalKtorfitApi::class)
public class _BeneficiaryServiceImpl(
  private val _ktorfit: Ktorfit,
) : BeneficiaryService {
  private val _helper: KtorfitConverterHelper = KtorfitConverterHelper(_ktorfit)

  override fun beneficiaryList(): Flow<List<Beneficiary>> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        method = HttpMethod.parse("GET")
        url{
        takeFrom(_ktorfit.baseUrl + "beneficiaries/tpt")
        } 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<Flow<List<Beneficiary>>>(),
    )
    return _helper.request(_typeData,_ext)!!
  }

  override fun beneficiaryTemplate(): Flow<BeneficiaryTemplate> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        method = HttpMethod.parse("GET")
        url{
        takeFrom(_ktorfit.baseUrl + "beneficiaries/tpt/template")
        } 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<Flow<BeneficiaryTemplate>>(),
    )
    return _helper.request(_typeData,_ext)!!
  }

  override suspend fun createBeneficiary(beneficiaryPayload: BeneficiaryPayload?): HttpResponse {
    val _ext: HttpRequestBuilder.() -> Unit = {
        method = HttpMethod.parse("POST")
        url{
        takeFrom(_ktorfit.baseUrl + "beneficiaries/tpt")
        }
        setBody(beneficiaryPayload) 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<HttpResponse>(),
    )
    return _helper.suspendRequest(_typeData,_ext)!!
  }

  override suspend fun updateBeneficiary(beneficiaryId: Long, payload: BeneficiaryUpdatePayload?): HttpResponse {
    val _ext: HttpRequestBuilder.() -> Unit = {
        method = HttpMethod.parse("PUT")
        url{
        takeFrom(_ktorfit.baseUrl + "beneficiaries/tpt/${"$beneficiaryId".encodeURLPath()}")
        }
        setBody(payload) 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<HttpResponse>(),
    )
    return _helper.suspendRequest(_typeData,_ext)!!
  }

  override suspend fun deleteBeneficiary(beneficiaryId: Long): HttpResponse {
    val _ext: HttpRequestBuilder.() -> Unit = {
        method = HttpMethod.parse("DELETE")
        url{
        takeFrom(_ktorfit.baseUrl + "beneficiaries/tpt/${"$beneficiaryId".encodeURLPath()}")
        } 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<HttpResponse>(),
    )
    return _helper.suspendRequest(_typeData,_ext)!!
  }
}

public class _BeneficiaryServiceProvider : ClassProvider<BeneficiaryService> {
  override fun create(_ktorfit: Ktorfit): BeneficiaryService = _BeneficiaryServiceImpl(_ktorfit)
}

public fun Ktorfit.createBeneficiaryService(): BeneficiaryService = _BeneficiaryServiceImpl(this)
